import {Report as ReportComponent } from './Report'

export const ReportQuery = ReportComponent;
